import React from "react";
import StatusBadge from "@/components/StatusBadge";
import { User } from "@phosphor-icons/react";

export default function OrderTable({ orders, onOpen }) {
  if (!orders?.length) {
    return (
      <div className="surface p-10 rounded-sm text-center text-slate-500 font-mono-num">
        No orders match your filter.
      </div>
    );
  }
  return (
    <div className="surface rounded-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="orders-table">
          <thead className="text-slate-500 font-mono-num text-[11px] tracking-widest bg-slate-800/50">
            <tr>
              <th className="text-left px-4 py-3">ORDER #</th>
              <th className="text-left">CUSTOMER</th>
              <th className="text-left">MOBILE</th>
              <th className="text-right">SQFT</th>
              <th className="text-right">TOTAL</th>
              <th className="text-right">BALANCE</th>
              <th className="text-left px-4">STATUS</th>
              <th className="text-left">BY</th>
              <th className="text-right px-4">CREATED</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr
                key={o.id}
                onClick={() => onOpen(o.id)}
                className="border-t border-slate-800 hover:bg-slate-800/40 cursor-pointer transition-colors"
                data-testid={`order-row-${o.order_number}`}
              >
                <td className="px-4 py-3 font-mono-num text-orange-400 font-semibold">#{o.order_number}</td>
                <td className="text-slate-200">{o.customer_name}</td>
                <td className="text-slate-400 font-mono-num">{o.mobile}</td>
                <td className="text-right font-mono-num text-cyan-300">{o.total_sqft}</td>
                <td className="text-right font-mono-num text-slate-200">₹{o.total_amount.toLocaleString("en-IN")}</td>
                <td className="text-right font-mono-num text-white">₹{o.balance.toLocaleString("en-IN")}</td>
                <td className="px-4"><StatusBadge status={o.status} /></td>
                <td className="text-slate-400 text-xs">
                  {o.created_by_name ? (
                    <span className="flex items-center gap-1"><User size={10}/>{o.created_by_name}</span>
                  ) : "—"}
                </td>
                <td className="text-right px-4 font-mono-num text-slate-500 text-xs">
                  {new Date(o.created_at).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
